import React, {
  memo,
  ReactElement,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} from "react";
import ReactDOM from "react-dom";

import events from "@/components/Joyspace/context/events";
import { Icons } from "@/components/Joyspace/Icon";
import { Button, Popover, Tooltip } from "antd";
import { debounce, throttle } from "lodash";
import styles from "./index.module.less";
function setName(name: string): string {
  if (name.length === 2) {
    return name.charAt(0) + " " + name.charAt(1);
  }
  return name;
}
function MenuItem(props: {
  type: string;
  disabled: boolean;
  tip?: any;
  callbackOrModal: (() => any) | React.ReactElement | undefined;
  name: string | React.ReactElement;
  setVisible: ((v: boolean) => any) | React.ReactElement | undefined;
}) {
  const { callbackOrModal, setVisible, disabled, tip, name, type } = props;
  return (
    <li
      key={type}
      className={`${styles["joyspace-li-batch-control"]} ${
        type === "delete" ? styles["batch-control-delete"] : ""
      }  `}
      onClick={(e) => {
        if (disabled) return;
        e.stopPropagation();
        e.preventDefault();
        if (typeof callbackOrModal === "function" && typeof setVisible === "function") {
          setVisible(false);
          callbackOrModal();
        } else if (React.isValidElement(callbackOrModal)) {
          ReactDOM.render(callbackOrModal, document.createDocumentFragment());
        }
      }}
    >
      {disabled ? (
        <Tooltip placement="left" title={tip}>
          <div key={type} className={styles["disabled-btn"]}>
            {setName(name as string)}
          </div>
        </Tooltip>
      ) : (
        <Button block={true} type="text">
          {props.name}
        </Button>
      )}
    </li>
  );
}
const btnPadding = 16;
const btnGap = 12;
const Menus = memo((props: { menus: any[] }) => {
  const { menus } = props;
  const [showBtnCount, setBtnCount] = React.useState(4);
  const [visible, setVisible] = React.useState(false);
  useEffect(() => {
    return () => {
      setVisible(false);
    };
  }, [menus]);
  const menusWidthArys = useMemo(() => {
    const widthAry: number[] = [];
    let width = 0;
    menus.forEach((menu) => {
      const menuWidth = Math.max(menu.name.length, 3) * 14 + btnPadding * 2 + btnGap;
      console.log(menuWidth, "widthAry:ls1", menu.name);
      width = menuWidth + width;
      widthAry.push(width);
    });
    console.log(widthAry, "widthAry:ls");
    return widthAry;
  }, [menus]);
  useEffect(() => {
    function doHandelResize() {
      const container = document.getElementsByClassName("joyspace-main-container")?.[0];
      if (container) {
        // @ts-ignore
        let width = Number(container.offsetWidth) - 22;
        let count = menusWidthArys.length;

        for (let index = 0; index < menusWidthArys.length; index++) {
          const element = menusWidthArys[index];
          if (index === menusWidthArys.length - 1) {
            width = width + 22;
          }
          if (width < element) {
            count = index;
            break;
          }
        }
        console.log(width, "menusWidthArys:ls", count);
        setBtnCount(count);
      }
    }
    const handelResize = debounce(() => {
      doHandelResize();
    }, 100);
    doHandelResize();
    window.addEventListener("resize", handelResize);
    events.on("left-nav-resize", handelResize);
    return () => {
      window.removeEventListener("resize", handelResize);
      events.off("left-nav-resize", handelResize);
    };
  }, [menusWidthArys]);

  const doClick = (e: React.MouseEvent, callbackOrModal?: any, setVisible?: any) => {
    e.stopPropagation();
    e.preventDefault();
    if (typeof callbackOrModal === "function") {
      typeof setVisible === "function" && setVisible(false);
      callbackOrModal();
    }
  };
  const handleVisibleChange = useCallback((visible: boolean) => {
    console.log("handleVisibleChange", visible);
    setVisible(visible);
  }, []);
  const content = useMemo(() => {
    const itemsMid: ReactElement[] = [];
    const itemsLeft: ReactElement[] = [];
    menus.forEach((menu) => {
      const { name, disabled, tip, callbackOrModal, type } = menu;

      if (itemsLeft.length < showBtnCount) {
        const button = !disabled ? (
          <Button
            type="default"
            key={type}
            onClick={(e) => {
              doClick(e, callbackOrModal);
            }}
            className={` ${type === "delete" ? styles["button-delete"] : ""}  `}
          >
            {name}
          </Button>
        ) : (
          <Tooltip placement="top" title={tip}>
            <div key={type} className={styles["disabled-btn"]}>
              {setName(name as string)}
            </div>
          </Tooltip>
        );
        itemsLeft.push(button);
        return;
      } else {
        itemsMid.push(
          <MenuItem
            type={type}
            disabled={disabled}
            key={type}
            setVisible={setVisible}
            name={name}
            callbackOrModal={callbackOrModal}
            tip={tip}
          />
        );
      }
    });
    return (
      <div className={styles["joyspace-list-bottom"]}>
        <div className={styles["batch-button-space"]} id="batch-button-space">
          {itemsLeft && <div className={styles["batch-button-space-left"]}>{itemsLeft}</div>}
          {itemsMid.length > 0 && (
            <div className={styles["batch-button-space-mid"]}>
              <Popover
                trigger="hover"
                onVisibleChange={handleVisibleChange}
                overlayClassName={styles["joyspace-popover-batch-control"]}
                visible={visible}
                content={<ul className={styles["joyspace-operate-lists"]}>{itemsMid}</ul>}
              >
                <div className={styles["joyspace-trigger-icon"]}>
                  <span>{Icons.trigger}</span>
                </div>
              </Popover>
            </div>
          )}
        </div>
      </div>
    );
  }, [menus, visible, showBtnCount]);

  return content;
});

export default Menus;
